import Layout from 'common/Layouts';
import Logo from 'common/Components/Logo';
import ActivationStepFactory from './components/ActivationStepFactory';

const AccountActivationDesktop = () => {
  return (
    <Layout strech>
      <Logo />
      <ActivationStepFactory />
    </Layout>
  );
};

export default AccountActivationDesktop;
